import React from 'react'
import {useParams} from "react-router-dom";
import {setShareEstimateItems} from "estimate_list/libs/cookie";
import {Loading} from "./loadingComponent";

const ShareURLComponent = () => {
    const { estimate_idx } = useParams();
    setShareEstimateItems(estimate_idx).then(() => {})
    return(
        <Loading/>
    )
}
export default ShareURLComponent



// WEBPACK FOOTER //
// ./src/estimate_list/common/shareURLComponent.js